import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { SimplebarAngularModule } from 'simplebar-angular';

import { NotificationTasksService } from '@app/services/notification-settings';
import { ReportsService } from '@app/services/reports/reports.service';
import { LanguageService } from '../core/services/language.service';
import { UIModule } from '../shared/ui/ui.module';
import { FooterComponent } from './footer/footer.component';
import { HorizontalComponent } from './horizontal/horizontal.component';
import { HorizontaltopbarComponent } from './horizontaltopbar/horizontaltopbar.component';
import { LayoutComponent } from './layout.component';
import { MenuLicenseListComponent } from './menu-license-list/menu-license-list.component';
import { MenuProjectLicenseListComponent } from './menu-project-license-list/menu-project-license-list.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { NotificationBellComponent } from './topbar/notification/notification-bell/notification-bell.component';
import { TopbarNotificationComponent } from './topbar/notification/topbar-notification/topbar-notification.component';
import { TopbarComponent } from './topbar/topbar.component';
import { VerticalComponent } from './vertical/vertical.component';

@NgModule({
  // tslint:disable-next-line: max-line-length
  declarations: [
    LayoutComponent, TopbarNotificationComponent, NotificationBellComponent,
    TopbarComponent, FooterComponent,
    HorizontalComponent, VerticalComponent,
    HorizontaltopbarComponent,
    SidebarComponent,
    MenuLicenseListComponent, MenuProjectLicenseListComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    BsDropdownModule.forRoot(),
    UIModule,
    SimplebarAngularModule,
    SharedModule
  ],
  providers: [LanguageService, NotificationTasksService, ReportsService]
})
export class LayoutsModule { }
